import { UploadFile } from "antd";
import { useEffect, useState } from "react";

import { FileTile, FileTileState } from "Components/ChatFiles/FileTile";
import { bytesToMegabytes } from "Components/ChatFiles/utils";

type Props = {
  file: UploadFile;
  onRetry: () => void;
  onDelete: () => void;
};

// HEIC браузеры не рисуют, поэтому показываем его карточкой файла
const isPreviewableImage = (file: File) => /^image\/(png|jpe?g|gif|webp)$/i.test(file.type);

const useLocalPreview = (file: File | undefined) => {
  const [previewUrl, setPreviewUrl] = useState<string>();

  useEffect(() => {
    if (!file || !isPreviewableImage(file)) return;
    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return previewUrl;
};

export const InputFileTile = ({ file, onRetry, onDelete }: Props) => {
  const originFile = file.originFileObj;
  const previewUrl = useLocalPreview(originFile);
  const kind = originFile && isPreviewableImage(originFile) ? "img" : "file";

  let state: FileTileState = "loaded";
  if (file.status === "error") state = "unloaded-input-error";
  else if (file.status === "uploading") state = kind === "img" ? "loading-preview" : "loading";

  return (
    <FileTile
      kind={kind}
      state={state}
      name={file.name}
      previewUrl={previewUrl}
      size={file.size ? bytesToMegabytes(file.size) : null}
      percent={file.percent}
      onClick={state === "unloaded-input-error" ? onRetry : undefined}
      onDelete={onDelete}
    />
  );
};
